import React from 'react'
import Hero from './components/Hero'
import ContactContent from './components/ContactContent'
import ContactForm from './components/ContactForm'

const Contact = () => {
  return (
    <section>
        <Hero />
        <ContactContent />
        <ContactForm />
    </section>
  )
}

export default Contact